import { useMutation, useQueryClient } from "@tanstack/react-query";
import { vinculosApi } from "../api/vinculosApi";
import { invalidateVinculoQueries } from "./invalidateVinculoQueries";
import { trackEvent } from "../../../shared/lib/analytics";

export function useUpdateVinculoMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...data }) => vinculosApi.update(id, data),
    onSuccess: () => {
      trackEvent("vinculo_editado");
      invalidateVinculoQueries(queryClient);
    },
  });
}
